<template>
  <div class="file-component"
       v-bind:class="{ 'has-error': hasError, uploaded: hasDocument }"
  >
    <div class="flex-row align-items-center gap-sm">
      <img v-if="hasPreview" :src="imagePreview">
      <div v-else class="icon icon-size-lg">
        <file-icon></file-icon>
      </div>
      <div class="flex-row width-stretch align-items-center gap-sm" v-if="!editing">
          <p class="overflow-x-hidden" :style="{ textOverflow: 'ellipsis' }">
            {{ name }}
          </p>
        <a-button type="link" v-if="hasDocument" @click="onEditClick">
          <pencil-icon></pencil-icon>
          wijzigen
        </a-button>
      </div>
      <a-input-search v-if="editing" v-model="name" placeholder="Bestandsnaam" @search="onSave">
        <a-button slot="enterButton" type="primary">
          Opslaan
        </a-button>
      </a-input-search>
    </div>
    <div class="flex-row justify-content-between align-items-center">
      <a-progress :status="progressBarStatus" :percent="percent"/>
      <HumanFilesizeComponent :bytes="file.size"></HumanFilesizeComponent>
    </div>
    <div v-if="hasError" class="flex-row">
       <span class="error">
            {{ errorMessage }}
       </span>
    </div>
  </div>
</template>
<script>
import documentApi from "~/api/document";
import HumanFilesizeComponent from "~/components/HumanFilesizeComponent";

const _utils = require('./utils');

export default {
  name: "FileComponent",
  props: {
    file: {
      type: File,
      required: true
    },
  },
  components: {
    HumanFilesizeComponent
  },
  data() {
    return {
      percent: 0,
      name: '',
      hasError: false,
      errorMessage: '',
      imagePreview: null,
      document: null,
      editing: false,
    };
  },
  computed: {
    progressBarStatus() {
      return this.hasError ? 'exception' : null;
    },
    isImage() {
      return _utils.isImageFileType(this.file.type);
    },
    hasPreview() {
      return this.imagePreview !== null;
    },
    hasDocument() {
      return this.document !== null;
    },
  },
  methods: {
    onError(error) {
      this.hasError = true;

      if (error.response) {
        if (error.response.status === 413) {
          this.errorMessage = 'Het bestand is te groot.';
        } else {
          this.errorMessage = 'Er ging iets fout tijdens het uploaden.';
        }
      }
    },
    onSuccess(document) {
      this.percent = 100;
      this.hasError = false;
      this.document = document;
    },
    onProgress(e) {
      let loaded = e.loaded,
              total = e.total;

      this.percent = loaded / (total / 100);
    },
    onEditClick() {
      this.editing = true;
    },
    onSave() {
      this.saving = true;
      this.document.name = this.name;

      documentApi.update(this.document).then(() => {
        this.saving = false;
        this.editing = false;
        this.$emit('updated-document', this.document);
      }).catch(() => {
        this.saving = false;
        this.$notification['error']({
          message: 'Er ging iets mis',
          description: 'Het is niet gelukt om de naam van het document te wijzigen',
        });
      });
    }
  },
  mounted() {
    if (this.isImage) {
      _utils.previewImage(this.file).then((preview) => {
        this.imagePreview = preview;
      });
    }

    this.name = this.file.name;
  }
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";

.file-component {
  background-color: $main-content-bg-color;
  border-radius: $border-radius-large;

  padding: $spacing-lg;
  max-width: 506px;
}
.drop-container {
  border: dashed 2px #d9d9d9;
}

.file-component.has-error {
  background: #fff3f3;
}

.preview {
  padding: 0 15px 0 0;
}

.preview img {
  width: 100%;
}

.preview > div.icon {
  padding: 8px 8px 13px 12px;
  font-size: 29px;
  border: solid 2px #00000014;
  border-radius: 3px;
  color: #0000009c;
}

.error {
  color: #ff000d;
  font-weight: 400;
}
</style>
